import React from 'react'
import PageLayout from '../components/PageLayout/PageLayout'
import StudentsContent from '../components/StudentsContent'
import { useTranslation } from 'react-i18next'

const Students = () => {
  const { t } = useTranslation()
  return (
    <PageLayout withHeader={true} title={t('STUDENTS')} crumbs={[]}>
      <StudentsContent />
    </PageLayout>
  )
}

export default Students
